import { useQuery } from "@tanstack/react-query";

import { getLeagueMappings } from "@/api/leaguesNew";
import { LeaguesNewQueryKeys } from "./leaguesNewQueryKeys";

export const useLeagueMappings = (leagueId: number | null) => {
  return useQuery({
    queryKey: [LeaguesNewQueryKeys.LeagueMappings, leagueId],
    queryFn: ({ signal }) =>
      getLeagueMappings(leagueId!, { signal, params: {} }),
    enabled: leagueId !== null,
  });
};
